import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/ui';
import { DefaultFieldsType, ErrorResponseContentInterface, ErrorResponseInterface } from '@systemeio/util';
import { WiseRecipientApiInterface, WiseRecipientId, WiseRecipientInterface } from 'modules/profile/affiliate-settings/types/affiliate-settings-interface';
import { BankDetailsFieldsErrorsErrorResponseContentInterface, WiseRecipientDetailsInterface } from 'modules/profile/affiliate-settings/types/wise-details-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
const WISE_RECIPIENT_API = '/api/dashboard/settings/affiliate-withdrawal/wise-recipient';
export const useWiseRecipientApi = setErrors => {
  const $ = _c(25);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: getFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.post
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: currentWiseFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] !== setErrors) {
    t2 = e => {
      const bankDetailsFieldsErrors = e.errors.fields as unknown as BankDetailsFieldsErrorsErrorResponseContentInterface;
      setErrors && setErrors(prev => {
        const updatedErrorState = {
          ...prev
        };
        if (bankDetailsFieldsErrors.accountHolderName) {
          updatedErrorState.fields.accountHolderName = bankDetailsFieldsErrors.accountHolderName;
        }
        if (bankDetailsFieldsErrors.details) {
          Object.keys(bankDetailsFieldsErrors.details).forEach(key => updatedErrorState.fields[key] = bankDetailsFieldsErrors.details[key]);
        }
        return updatedErrorState;
      });
    };
    $[2] = setErrors;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const badRequestHandler = t2;
  let t3;
  if ($[4] !== badRequestHandler) {
    t3 = {
      method: RequestMethodsEnum.post,
      badRequestHandler
    };
    $[4] = badRequestHandler;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    fetcher: addWiseFetcher
  } = useFetch(t3);
  let t4;
  if ($[6] !== badRequestHandler) {
    t4 = {
      method: RequestMethodsEnum.put,
      badRequestHandler
    };
    $[6] = badRequestHandler;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    fetcher: updateWiseFetcher
  } = useFetch(t4);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      method: RequestMethodsEnum.delete
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t5);
  let t6;
  if ($[9] !== getFetcher) {
    t6 = currency => getFetcher(`${WISE_RECIPIENT_API}/details/${currency}`);
    $[9] = getFetcher;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const getDefaultWiseRecipientDetails = t6;
  let t7;
  if ($[11] !== currentWiseFetcher) {
    t7 = (currency_0, data) => currentWiseFetcher(`${WISE_RECIPIENT_API}/details/${currency_0}`, data);
    $[11] = currentWiseFetcher;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const getCurrentWiseRecipientDetails = t7;
  let t8;
  if ($[13] !== updateWiseFetcher) {
    t8 = (id, data_0) => updateWiseFetcher(`${WISE_RECIPIENT_API}/${id}`, data_0);
    $[13] = updateWiseFetcher;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const updateWiseRecipientDetails = t8;
  let t9;
  if ($[15] !== addWiseFetcher) {
    t9 = data_1 => addWiseFetcher(`${WISE_RECIPIENT_API}`, data_1);
    $[15] = addWiseFetcher;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const addWiseRecipientDetails = t9;
  let t10;
  if ($[17] !== deleteFetcher) {
    t10 = id_0 => deleteFetcher(`${WISE_RECIPIENT_API}/${id_0}`);
    $[17] = deleteFetcher;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const deleteWiseRecipientDetails = t10;
  let t11;
  if ($[19] !== addWiseRecipientDetails || $[20] !== deleteWiseRecipientDetails || $[21] !== getCurrentWiseRecipientDetails || $[22] !== getDefaultWiseRecipientDetails || $[23] !== updateWiseRecipientDetails) {
    t11 = {
      getCurrentWiseRecipientDetails,
      getDefaultWiseRecipientDetails,
      updateWiseRecipientDetails,
      addWiseRecipientDetails,
      deleteWiseRecipientDetails
    };
    $[19] = addWiseRecipientDetails;
    $[20] = deleteWiseRecipientDetails;
    $[21] = getCurrentWiseRecipientDetails;
    $[22] = getDefaultWiseRecipientDetails;
    $[23] = updateWiseRecipientDetails;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};